import { Grid, TextField } from '@mui/material'
import { CompanyAutocomplete } from '@planning/components/autocompletes/company-autocomplete/CompanyAutocomplete'
import { RailVisitGeneralInformationFormStore } from '@planning/pages/RailVisit/stores/RailVisitGeneralInformationFormStore'
import { SectionSubtitle } from '@planning/pages/VesselVisit/Components/atoms/SectionSubtitle'
import { useTranslate } from '@tolgee/react'
import { useMinimalsTheme } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { RailVisitVoyageSubForm } from './RailVisitVoyageSubForm'

type RailVisitGeneralInformationSubFormProps = {
  store: RailVisitGeneralInformationFormStore
  isEditMode: boolean
}

export const RailVisitGeneralInformationSubForm = observer(
  (props: RailVisitGeneralInformationSubFormProps) => {
    const { store } = props
    const { t } = useTranslate()
    const theme = useMinimalsTheme()

    return (
      <Grid container spacing={theme.customSpacing.s}>
        <Grid size={{ xs: 12 }}>
          <SectionSubtitle label={t('generalInformation', 'General information')} />
        </Grid>

        <Grid size={{ xs: 12 }}>
          <TextField
            {...store.trainName.props}
            data-cy='train-name-field'
            fullWidth
            label={t('trainName', 'Train Name')}
            variant='outlined'
            type='text'
            name={`trainName`}
            required
          />
        </Grid>

        <Grid size={{ xs: 12 }}>
          <CompanyAutocomplete
            label={t('trainOperator', 'Train Operator')}
            filterByTypes={['TrainOperator']}
            selectedCompanyShortName={store.trainOperator.initialValue}
            handleOnChange={company => {
              store.trainOperator.setValue(company?.shortName)
            }}
          />
        </Grid>

        <Grid size={{ xs: 12 }}>
          <SectionSubtitle label={t('tripIds', "Trip ID's")} />
        </Grid>

        <Grid size={{ xs: 12 }}>
          <RailVisitVoyageSubForm store={store} />
        </Grid>
      </Grid>
    )
  },
)
